// select menu options for generic Select Menu
const FieldModalMenuOptions = [
  { title: 'Aquastride', value: { type: 'aquastride' } },
  { title: 'Galcon', value: { type: 'galcon' } },
  { title: 'Motorola', value: { type: 'motorola' } },
  { title: 'Tal Gil', value: { type: 'tal-gil' } },
  { title: 'N-Drip Piezometer', value: { type: 'piezometer' } },
  { title: 'N-Drip Pulse', value: { type: 'pulse' } },
  { title: 'N-Drip Tensiometer', value: { type: 'wp' } },
  { title: 'N-Drip High Pressure', value: { type: 'high_pressure' } },
  { title: 'N-Drip Low Pressure', value: { type: 'low_pressure' } },
  { title: 'Soil Temp Sensor', value: { type: 'soil_temp' } },
  { title: 'AI Irrigator', value: { type: 'ndrip-ai' } },
];

const FarmingUnitModalMenuOptions = [
  // {title: 'N-Drip Pulse', value: {type: 'pulse'}},
  { title: 'Tal Gil', value: { type: 'tal-gil' } },
];

module.exports = {
  FieldModalMenuOptions,
  FarmingUnitModalMenuOptions,
};
